import React, { Component } from "react";
import { Dialog, List, ListItem, DialogTitle, DialogActions, IconButton, Icon, Menu, withStyles, Grid, Fab, Select, MenuItem, TextField, Card, InputLabel, Button, Checkbox, Tooltip } from "@material-ui/core";
import * as actions from '../../store/actions/index';
import { connect } from "react-redux";
import { compose } from 'redux';
import FontAwesome from "react-fontawesome";
import _ from 'lodash'
import EmailTypeOne from "../CommonLogUI/EmailTypeOne";
import EmailTypeTwo from "../CommonLogUI/EmailTypeTwo";
import EmailTypeFour from "../CommonLogUI/EmailTypeFour";
import SystemLog from "../CommonLogUI/SystemLog"
import NoteLog from "../CommonLogUI/NoteLog";
import CallLogs from "../CommonLogUI/CallLogs";
import RingCentralCallLogs from "../CommonLogUI/RingCentralCallLogs";
import ViewHtmlDialog from "../CommonLogUI/ViewHtmlDialog";
import "date-fns";
import moment from 'moment';
import InboxComposeDialog from "../CommonComposeMail/InboxComposeDialog";
import FilterLogoCommon from "../CommonLogUI/FilterLogoCommon";

class OpportunitiesEmailLogs extends Component {
    state = {
        viewHtmlData: '',
        shouldOpenViewEmailDialog: false,
        FullViewEmailDialog: false,
        minimizeViewEmailDialog: false,
        selectedDate: new Date(),
        isOpenedEmailIds: [],
        isOpenedReplayEmailLog: false,
        allLogs: [],
        logvaluetype: 'Phone Call',
        logtype: '',
        textvalue: '',
        dateformat: 'MM/DD/YYYY',
        timeZone: 'America/New_York',
        FullCreateOpportunitiesDialog: false,
        minimizeOpportunitiesDialog: false,
        isDeleteLogConfirmDialoOpen: false,
        isEditLog: false,
        isEditComment: false,
        logid: '',
        commentid: '',
        Commentoptions: '',
        showCommentoptions: false,
        isOpenedCommentIds: [],
        logtypeid: [],
        activitypeid: [],
        activities: [],
        userid: "",
        showSelector: false,
        reactions: ["👍", "🔥", "😍", "🎉", "👏", "💯", "😎", "😂", "😭", "⛳️", "🙂", "🎯", "🍾", "😢", "❤️"],
        allSettings: "",
        emaildata: [],
        mainUserData: [],
        isSendNewMail: false,
        userSelectedEmail: "",
        userName: ""
    };

    componentDidMount() {
        this.props.getEmailSetting(this.props.apolloClient.client);
        this.props.getActivityTypes(this.props.apolloClient.client);
        let userData = JSON.parse(localStorage.getItem('user_data_session'))
        this.setState({ userid: userData.id })
    };

    findWithAttr = (array, attr, value) => {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    };

    componentWillReceiveProps(props) {
        if (props.opportunityReducer.opportunityFieldData.data && props.opportunityReducer.opportunityFieldData.data.length > 0 && props.opportunityReducer.opportunityFieldData.is_loaded) {
            var data = props.opportunityReducer.opportunityFieldData.data;
            var mainIntemplate = {};
            data.map((details, index) => {
                if (details.fieldkey == "name") {
                    mainIntemplate.fullname = details.opportunitiesdetail[0].fieldvalue;
                    mainIntemplate.firstname = (details.opportunitiesdetail.length > 0 && details.opportunitiesdetail[0].values.firstname) ? details.opportunitiesdetail[0].values.firstname : "";
                    mainIntemplate.lastname = (details.opportunitiesdetail.length > 0 && details.opportunitiesdetail[0].values.lastname) ? details.opportunitiesdetail[0].values.lastname : "";
                    this.setState({ userName: details.opportunitiesdetail.length > 0 ? details.opportunitiesdetail[0].fieldvalue : null })
                }
                if (details.fieldkey == "email" || details.fieldkey == "phones") {
                    mainIntemplate[details.fieldkey] = (details.opportunitiesdetail.length > 0 && details.opportunitiesdetail[0].values.length > 0) ? details.opportunitiesdetail[0].values[0].value : null
                }
                if (details.fieldkey == "title" || details.fieldkey == "address") {
                    mainIntemplate[details.fieldkey] = (details.opportunitiesdetail.length > 0 && details.opportunitiesdetail[0].fieldvalue) ? details.opportunitiesdetail[0].fieldvalue : null
                }
                if (details.fieldkey == "owner") {
                    mainIntemplate.owner = (details.opportunitiesdetail.length > 0 && details.opportunitiesdetail[0].values.length > 0) ? details.opportunitiesdetail[0].values[0].name : null
                }
                if (details.fieldkey == "email") {
                    this.setState({
                        userSelectedEmail: (details.opportunitiesdetail.length > 0 && details.opportunitiesdetail[0].values.length > 0) ? details.opportunitiesdetail[0].values[0].value : null
                    })
                }
            })
            this.setState({
                mainUserData: mainIntemplate
            })
        }

        if (props.settingReducer.emailsettings.data) {
            const mian_data = props.settingReducer.emailsettings.data
            this.setState({ allSettings: mian_data, })
        }

        if (props.settingReducer.userSettingArray && props.settingReducer.userSettingArray.data) {
            let usersetting = props.settingReducer.userSettingArray.data;
            let format = usersetting.dateformat;
            let timezone = usersetting.timezone;
            this.setState({ dateformat: format, timeZone: timezone })
        }

        if (props.settingReducer.masterActivityTypesList) {
            this.setState({ activities: props.settingReducer.masterActivityTypesList.data });
        }

        if (props.opportunityReducer.opportunityLogList && props.opportunityReducer.opportunityLogList.data && props.opportunityReducer.opportunityLogList.data.logdata && props.opportunityReducer.opportunityLogList.data.logdata.length > 0) {
            let logged_in_user_email = JSON.parse(localStorage.getItem("user_data_session")).email;
            let logData = [];
            let results = [];
            let resultList = [];
            props.opportunityReducer.opportunityLogList.data.logdata.map((data) => {
                if (data.logtype == 0) {
                    resultList.push({
                        str: moment.unix(data.logdate).tz(this.state.timeZone).format('MMM YYYY')
                    })
                } else {
                    resultList.push({
                        str: moment.unix(data.createddate).tz(this.state.timeZone).format('MMM YYYY')
                    })
                }
            })
            let name = '';
            let source = '';
            if (props.opportunityReducer.opportunityFieldData.data) {
                let fieldSource = props.opportunityReducer.opportunityFieldData.data;
                var sourcekey = this.findWithAttr(fieldSource, 'fieldkey', 'name');

                if (fieldSource[sourcekey].opportunitiesdetail && fieldSource[sourcekey].opportunitiesdetail[0].fieldvalue)
                    source = fieldSource[sourcekey].opportunitiesdetail[0].fieldvalue;
            }
            results['Pinned'] = [];
            let results_pined_ids = [];
            resultList.map((mont) => {
                results[mont.str] = [];
                props.opportunityReducer.opportunityLogList.data.logdata.map((data) => {
                        let pinned = data.ispined;

                        if (data.email_type) {
                            if (mont.str == moment.unix(data.createddate).tz(this.state.timeZone).format('MMM YYYY')) {
                                let log_user = JSON.parse(localStorage.getItem('user_data_session'));
                                let color_class = (log_user.name) ? log_user.name.charAt(0) : "";
    
                                if (data.email_type == 1) {
                                    let date = moment(data.details.email_date_time).format("X");
                                    logData.push(
                                        {
                                            logId: data.id,
                                            emojidetail: data.emojidetail && data.emojidetail !== null ? JSON.parse(data.emojidetail) : [],
                                            ispined: pinned,
                                            emailtype: 1,
                                            name: data.name,
                                            email: data.email,
                                            color: color_class,
                                            comments: data.__commentlist__,
                                            attachment: data.attachment,
                                            emaildetails: data.details,
                                            emailTo: data.emailTo,
                                            snippet: data.details.snippet,
                                            subject: data.details.subject,
                                            body_html: data.details.body_html,
                                            email_date_time: moment.unix(data.createddate).tz(this.state.timeZone).format(this.state.dateformat) + ", " + moment.unix(data.createddate).tz(this.state.timeZone).format('hh:mm a'),
                                        }
                                    );
                                }
                                else if (data.email_type == 2) {
                                    logData.push(
                                        {
                                            logId: data.id,
                                            emojidetail: data.emojidetail && data.emojidetail !== null ? JSON.parse(data.emojidetail) : [],
                                            ispined: pinned,
                                            emailtype: 2,
                                            name: data.name,
                                            email: data.email,
                                            color: color_class,
                                            comments: data.__commentlist__,
                                            attachment: data.attachment,
                                            emaildetails: data.details,
                                            emailTo: data.emailTo,
                                            snippet: data.details.snippet,
                                            subject: data.details.subject,
                                            body_html: data.details.body_html,
                                            email_date_time: moment.unix(data.createddate).tz(this.state.timeZone).format(this.state.dateformat) + ", " + moment.unix(data.createddate).tz(this.state.timeZone).format('hh:mm a'),
                                        }
                                    );
                                }
                                else if (data.email_type == 4) {
                                    logData.push(
                                        {
                                            logId: data.id,
                                            emojidetail: data.emojidetail && data.emojidetail !== null ? JSON.parse(data.emojidetail) : [],
                                            emailtype: 4,
                                            ispined: pinned,
                                            name: data.name,
                                            email: data.email,
                                            color: color_class,
                                            comments: data.__commentlist__,
                                            attachment: data.attachment,
                                            emaildetails: data.details,
                                            emailTo: data.emailTo,
                                            snippet: data.details.snippet,
                                            subject: data.details.subject,
                                            body_html: data.details.body_html,
                                            email_date_time: moment.unix(data.createddate).tz(this.state.timeZone).format(this.state.dateformat) + ", " + moment.unix(data.createddate).tz(this.state.timeZone).format('hh:mm A'),
                                        }
                                    );
                                }
                            }
                        } else {
                            if (!data.email_type && data.propertyname && data.propertyname === "Email") {
                                if (mont.str == moment.unix(data.logdate).tz(this.state.timeZone).format('MMM YYYY') && data.logtype == 0 ) {
                                    let pinned = data.ispined;
                                    let template = data.template;
                                    let color_class = (data.__user__.name) ? data.__user__.name.charAt(0) : "";
                                    let text = (data.text) ? data.text : "";
                                    let loguser = (data.__user__.email == logged_in_user_email) ? 'You' : data.__user__.name;
                                    let template1 = (data.template) ? template.replace("{{user}}", loguser) : "";
    
                                    let new_template = "";
    
                                    let create_date = data.createddate;
                                    let updateddate = data.updateddate;
    
                                    if (data.logtype == 0) // Email log
                                    {
                                        updateddate = data.logdate;
                                        new_template = template1.replace("{{property_name}}", '"' + data.propertyname + '"');
                                    }
    
                                    if (new_template != "") {
                                        logData.push({
                                            logId: data.id,
                                            mentionid: data.mentionid,
                                            mentiondetail: data.mentiondetail ? data.mentiondetail : "",
                                            emojidetail: data.emojidetail && data.emojidetail !== null ? JSON.parse(data.emojidetail) : [],
                                            creaetedDate: moment.unix(create_date).tz(this.state.timeZone).format(this.state.dateformat),
                                            emailtype: 0,
                                            comments: data.__commentlist__,
                                            activitytype: data.__activitytype__,
                                            user: data.__user__.name,
                                            useremail: data.__user__.email,
                                            propertyType: data.propertyname,
                                            color: color_class,
                                            template: new_template,
                                            ispined: pinned,
                                            text: text,
                                            logtype: data.logtype,
                                            time: (updateddate != null)
                                                ?
                                                moment.unix(updateddate).tz(this.state.timeZone).format('hh:mm a')
                                                :
                                                moment.unix(create_date).tz(this.state.timeZone).format('hh:mm a'),
                                            date: (updateddate != null)
                                                ?
                                                moment.unix(updateddate).tz(this.state.timeZone).format(this.state.dateformat)
                                                :
                                                moment.unix(create_date).tz(this.state.timeZone).format(this.state.dateformat)
                                        });
                                    }
                                }
                            }
                        }

                        if (logData.length > 0) {
                            if (logData[0].ispined && logData[0].ispined == true) {
                                if (results_pined_ids.indexOf(logData[0].logId) == -1) {
                                    results['Pinned'].push(logData);
                                    results_pined_ids.push(logData[0].logId);
                                }
                            } else {
                                results[mont.str].push(logData);
                            }
                            logData = []
                        }
                });
            });
            let temp_arr1 = [];

            Object.keys(results).forEach(function (key) {
                let temp_arr2 = [];
                if (key === 'Pinned') {
                    temp_arr2['key'] = 'Pinned';
                    temp_arr2['log'] = results['Pinned'];
                    if (results['Pinned'] && results['Pinned'].length > 0) {
                        temp_arr1.push(temp_arr2);
                    }
                } else if (key !== 'Pinned') {
                    temp_arr2['key'] = key;
                    temp_arr2['log'] = results[key];
                    if (results[key] && results[key].length > 0) {
                        temp_arr1.push(temp_arr2);
                    }
                }
            })
            this.setState({ allLogs: temp_arr1, opportunities_id: props.opportunities_id });
        }
        else if (props.opportunityReducer.opportunityLogList && props.opportunityReducer.opportunityLogList.data && props.opportunityReducer.opportunityLogList.data.logdata && props.opportunityReducer.opportunityLogList.data.logdata.length <= 0) {
            this.setState({ allLogs: [], opportunities_id: props.opportunities_id });
        }
    }

    togglePin = (logId, pinned) => {
        let emailParam = localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '';
        let pinParams = {
            ispined: !pinned,
            logid: parseFloat(logId),
            recordid: parseFloat(this.state.opportunities_id),
            recordtypeid: 2,
            emailid: emailParam,
            logtypeid: this.state.logtypeid,
            activitypeid: this.state.activitypeid
        }
        this.props.addLogPined(this.props.apolloClient.client, pinParams);
    }


    handleViewEmailDialogClose = () => {
        this.setState({ shouldOpenViewEmailDialog: false, FullViewEmailDialog: false, minimizeViewEmailDialog: false });
    };

    handlechange = (event, logid) => {
        this.setState({ [event.target.name]: event.target.value, logid: logid })
    };

    handleDateChange = date => {
        this.setState({ selectedDate: date });
    };

    handleCancelAddLog = () => {
        this.setState({ textvalue: '' })
    };

    handleSaveEditLog = () => {
        let date_test = moment(this.state.selectedDate).format('YYYY-MM-DD HH:mm');
        var logdate = moment.tz(date_test, this.state.timeZone).format();
        var date = moment.utc(logdate).format('X');
        let textvalue = this.state.textvalue;
        let saveLogparams = [];

        saveLogparams['update'] = {
            text: textvalue,
            logtime: parseFloat(date),
            logdate: parseFloat(date),
            logid: parseFloat(this.state.logid),
        };
        let emailParam = localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '';
        saveLogparams['getlog'] = { emailid: emailParam, opportunitiesid: parseFloat(this.props.opportunities_id), activitypeid: this.state.activitypeid, logtypeid: this.state.logtypeid };

        this.props.updateOpportunitiesLog(this.props.apolloClient.client, saveLogparams);
        this.setState({ isEditLog: false })
    };

    handleEditLog = (id, date, time, text) => {
        let date1 = new Date(date + ',' + time);
        this.setState({ isEditLog: true, textvalue: text, selectedDate: date1, logid: id });
    };

    handleCancelEdit = () => {
        this.setState({ isEditLog: false })
    };

    //------delete log
    handleDeleteLog = (logid) => {
        this.setState({ logid: logid });
        this.toggleDeleteDialog()
    };

    toggleDeleteDialog = () => {
        this.setState({ isDeleteLogConfirmDialoOpen: !this.state.isDeleteLogConfirmDialoOpen });
    };

    confirmDeleteLog = () => {
        let emailParam = localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '';
        let deletelogParams = { logid: parseFloat(this.state.logid), opportunitiesid: parseFloat(this.state.opportunities_id), emailid: emailParam, activitypeid: this.state.activitypeid, logtypeid: this.state.logtypeid };
        this.props.deleteOpportunitiesLogDetail(this.props.apolloClient.client, deletelogParams);
        this.toggleDeleteDialog()
    };

    //email menu functions
    handleEmailHtmlPopupMain = (logdata) => {
        this.setState({ shouldOpenViewEmailDialog: true, viewHtmlData: logdata });
    };

    //- comments-----------------
    toggleComment = (logid) => {
        let isOpenedCommentIds = this.state.isOpenedCommentIds;

        if (isOpenedCommentIds.indexOf(logid) == -1) {
            isOpenedCommentIds.push(logid);
        }
        else {
            let index = isOpenedCommentIds.indexOf(logid);
            isOpenedCommentIds.splice(index, 1);
        }

        this.setState(({ commentvalue: "", logid: logid, isOpenedCommentIds: isOpenedCommentIds }));
    };

    handleCancelComment = () => {
        this.setState({ commentvalue: '' });
    };

    handleSaveCommentLog = (type) => {
        const textvalue = this.state.commentState.textvalue
        const raw = this.state.commentState.raw
        let mention = [];
        Object.entries(raw.entityMap).map((entity) => {
            if (mention.indexOf(entity[1].data.mention.id) == -1) {
                mention.push(parseFloat(entity[1].data.mention.id))
            }
        });
        let emailParam = localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '';
        let commentParams = {
            type: type,
            comment: this.state.commentvalue,
            logid: parseFloat(this.state.logid),
            opportunitiesid: parseFloat(this.state.opportunities_id),
            emailid: emailParam, logtypeid: this.state.logtypeid,
            activitypeid: this.state.activitypeid,
            mentionuser: mention,
            mentiondetail: "",
        };
        this.props.addOpportunitiesLogComment(this.props.apolloClient.client, commentParams);
        this.setState({ commentvalue: '' });
    };

    //-edit comment
    handleSaveEditComment = (type) => {
        const textvalue = this.state.commentState.textvalue
        const raw = this.state.commentState.raw
        let mention = [];
        Object.entries(raw.entityMap).map((entity) => {
            if (mention.indexOf(entity[1].data.mention.id) == -1) {
                mention.push(parseFloat(entity[1].data.mention.id))
            }
        });
        let emailParam = localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '';
        let commentParams = {
            type: type,
            commentid: parseFloat(this.state.commentid),
            comment: this.state.commentvalue,
            opportunitiesid: parseFloat(this.state.opportunities_id),
            emailid: emailParam,
            logtypeid: this.state.logtypeid,
            activitypeid: this.state.activitypeid,
            mentionuser: mention,
            mentiondetail: "",
        };
        this.setState({ commentvalue: '', isEditComment: false, commentid: '' });
        this.props.updateOpportunitiesLogComment(this.props.apolloClient.client, commentParams);
    };

    handleEditCommentMain = (id, comment) => {
        this.setState({ isEditComment: true, commentvalue: comment, commentid: id });
    };

    handleCancelEditComment = () => {
        this.setState({ isEditComment: false, commentvalue: '' })
    };

    //-delete comment
    deleteComment = (cmt_id, type) => {
        let emailParam = localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '';
        let commentParams = {
            commentid: cmt_id,
            type: type,
            emailid: emailParam,
            opportunitiesid: parseFloat(this.state.opportunities_id),
            activitypeid: this.state.activitypeid,
            logtypeid: this.state.logtypeid
        };
        this.props.deleteOpportunitiesLogComment(this.props.apolloClient.client, commentParams);
    };
    //--------------comments functions-----------

    //---- email functions
    toggleEmail = (id) => {
        let isOpenedEmailIds = this.state.isOpenedEmailIds;

        if (isOpenedEmailIds.indexOf(id) == -1) {
            isOpenedEmailIds.push(id);
        }
        else {
            let index = isOpenedEmailIds.indexOf(id);
            isOpenedEmailIds.splice(index, 1);
        }

        this.setState(({ logid: id, isOpenedEmailIds: isOpenedEmailIds }));
    };

    toggleReplayEmailLog = () => {
        this.setState({
            isOpenedReplayEmailLog: !this.state.isOpenedReplayEmailLog
        });
    };

    componentWillUnmount() {
        localStorage.removeItem('emailLogEmail');
    };
    //------------

    // -- get all months between two dates
    getMonths = (startDate, endDate) => {
        var resultList = [];
        var date = moment.unix(startDate).tz(this.state.timeZone)._d;
        var endDate = moment.unix(endDate).tz(this.state.timeZone)._d;

        var monthNameList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        while (date.getMonth() <= endDate.getMonth() + 1) {
            var stringDate = monthNameList[date.getMonth()] + " " + date.getFullYear();

            //get first and last day of month
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            resultList.push({
                str: stringDate,
            });
            date.setMonth(date.getMonth() + 1);
        }
        resultList.reverse();
        return resultList;
    };

    handlefiltermain = (types, activities) => {
        let emailParam = localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '';
        this.setState({ logtypeid: types, activitypeid: activities });

        let getfilterLogParam = { opportunitiesid: this.state.opportunities_id, emailid: emailParam, logtypeid: types, activitypeid: activities }
        this.props.getOpportunitiesLogListNew(this.props.apolloClient.client, getfilterLogParam);
    };

    handleAdd = (log) => this.setState({ showSelector: !this.state.showSelector, logid: log.logId });

    handleSelect = (emoji, data) => {
        const index = data.emojidetail.findIndex(obj => obj.emoji === emoji && obj.by === this.state.userid)
        var main_data = data.emojidetail;
        if (index > -1) {
            main_data = [...main_data.slice(0, index), ...main_data.slice(index + 1)]
        } else {
            main_data = [...main_data, { emoji, by: this.state.userid }]
        }
        this.setState({ showSelector: false })

        let emailParam = localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '';

        let req = {
            logid: data.emailtype !== 0 ? parseFloat(data.emaildetails.id) : parseFloat(data.logId),
            emoji: emoji,
            emojidetail: JSON.stringify(main_data),
            opportunitiesid: parseFloat(this.state.opportunities_id),
            activitypeid: this.state.activitypeid,
            emailid: emailParam,
            logtypeid: this.state.logtypeid,
            logtype: data.emailtype !== 0 ? "email" : "log"
        }
        this.props.addOpportunitiesLogEmoji(this.props.apolloClient.client, req)
    };

    isOpenedClickEmailToggle = () => {
        this.setState({
            isSendNewMail: !this.state.isSendNewMail
        })
    };

    openNewMail = (log) => {
        this.setState({ isOpenedReplayEmailLog: true, logid: log.logId, emaildata: log });
    };

    getdata = (data) => {
        console.log("data ....", data)
        this.setState({ commentvalue: data.textvalue, commentState: data })
    };

    getEditCommentData = (data) => {
        console.log("data edit ....", data)
        this.setState({ commentvalue: data.textvalue, commentState: data })
    };

    saveId = (id, date) => {
        this.setState({ logid: id, selectedDate: date })
    };

    AddNewLog = (log) => {
        this.setState({
            logtype: log.logtype,
            logvaluetype: log.propertyType,
        })
    };

    render() {
        const { isOpenedReplayEmailLog, commentvalue, allLogs, logvaluetype, isOpenedComment, textvalue, selectedDate, minimizeOpportunitiesDialog, FullCreateOpportunitiesDialog } = this.state
        let loghtml = [];
        let logheader = [];
        let logbody = [];
        let user_data = JSON.parse(localStorage.getItem('user_data_session'));
        let current_logUser = user_data.email;
        let allowUserReply = user_data.googlestatus === true && this.state.allSettings.setting_one && this.state.allSettings.setting_one === 1 ? true : false
        allLogs.map((logdata) => {
            logheader = [];
            logbody = [];
            logheader.push(
                <FilterLogoCommon headerKey={logdata.key} />
            )

            logdata['log'].map((log) => {
                log = log[0];
                if (log.emailtype != 0) {
                    if (log.emailtype == 1) {
                        logbody.push(
                            <EmailTypeOne
                                allowUserReply={allowUserReply}
                                commentvalue={commentvalue}
                                log={log}
                                logid={this.state.logid}
                                userName={this.state.userName}
                                opportunities_id={this.state.opportunities_id}
                                isOpenedEmailIds={this.state.isOpenedEmailIds}
                                showSelector={this.state.showSelector}
                                dateformat={this.state.dateformat}
                                timeZone={this.state.timeZone}
                                commentid={this.state.commentid}
                                isOpenedCommentIds={this.state.isOpenedCommentIds}
                                isEditComment={this.state.isEditComment}
                                thatAll={this}
                                isOpenedReplayEmailLog={isOpenedReplayEmailLog}
                                transferLink={"/opportunities/opportunities/" + this.state.opportunities_id}
                                mainUserData={this.state.mainUserData}
                                emaildata={this.state.emaildata}
                                LogDetails={{
                                    opportunitiesid: parseFloat(this.state.opportunities_id),
                                    emailid: localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '',
                                    logtypeid: this.state.logtypeid,
                                    activitypeid: this.state.activitypeid,
                                }}
                                LogComponent="Opportunities"
                            />
                        )
                    }
                    else if (log.emailtype == 2) {
                        logbody.push(
                            <EmailTypeTwo
                                allowUserReply={allowUserReply}
                                commentvalue={commentvalue}
                                log={log}
                                logid={this.state.logid}
                                userName={this.state.userName}
                                opportunities_id={this.state.opportunities_id}
                                isOpenedEmailIds={this.state.isOpenedEmailIds}
                                showSelector={this.state.showSelector}
                                dateformat={this.state.dateformat}
                                timeZone={this.state.timeZone}
                                commentid={this.state.commentid}
                                isOpenedCommentIds={this.state.isOpenedCommentIds}
                                isEditComment={this.state.isEditComment}
                                thatAll={this}
                                isOpenedReplayEmailLog={isOpenedReplayEmailLog}
                                transferLink={"/opportunities/opportunities/" + this.state.opportunities_id}
                                mainUserData={this.state.mainUserData}
                                emaildata={this.state.emaildata}
                                LogDetails={{
                                    opportunitiesid: parseFloat(this.state.opportunities_id),
                                    emailid: localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '',
                                    logtypeid: this.state.logtypeid,
                                    activitypeid: this.state.activitypeid,
                                }}
                                LogComponent="Opportunities" />
                        )
                    }
                    else if (log.emailtype == 4) {
                        logbody.push(
                            <EmailTypeFour
                                allowUserReply={allowUserReply}
                                commentvalue={commentvalue}
                                log={log}
                                logid={this.state.logid}
                                userName={this.state.userName}
                                opportunities_id={this.state.opportunities_id}
                                isOpenedEmailIds={this.state.isOpenedEmailIds}
                                showSelector={this.state.showSelector}
                                dateformat={this.state.dateformat}
                                timeZone={this.state.timeZone}
                                commentid={this.state.commentid}
                                isOpenedCommentIds={this.state.isOpenedCommentIds}
                                isEditComment={this.state.isEditComment}
                                thatAll={this}
                                isOpenedReplayEmailLog={isOpenedReplayEmailLog}
                                transferLink={"/opportunities/opportunities/" + this.state.opportunities_id}
                                mainUserData={this.state.mainUserData}
                                emaildata={this.state.emaildata}
                                LogDetails={{
                                    opportunitiesid: parseFloat(this.state.opportunities_id),
                                    emailid: localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '',
                                    logtypeid: this.state.logtypeid,
                                    activitypeid: this.state.activitypeid,
                                }}
                                LogComponent="Opportunities" />
                        )
                    }
                } else {
                    if (log.logtype == 0) {
                        logbody.push(
                            <CallLogs
                                thatAll={this}
                                log={log}
                                commentvalue={this.state.commentvalue}
                                selectedDate={this.state.selectedDate}
                                logid={this.state.logid}
                                dateformat={this.state.dateformat}
                                showSelector={this.state.showSelector}
                                isOpenedCommentIds={this.state.isOpenedCommentIds}
                                isEditComment={this.state.isEditComment}
                                commentid={this.state.commentid}
                                timeZone={this.state.timeZone}
                            />)
                    } else if (log.logtype == 1000) {
                        logbody.push(
                            <RingCentralCallLogs
                                thatAll={this}
                                log={log}
                                commentvalue={this.state.commentvalue}
                                selectedDate={this.state.selectedDate}
                                logid={this.state.logid}
                                dateformat={this.state.dateformat}
                                showSelector={this.state.showSelector}
                                isOpenedCommentIds={this.state.isOpenedCommentIds}
                                isEditComment={this.state.isEditComment}
                                commentid={this.state.commentid}
                                timeZone={this.state.timeZone}
                            />)
                    }
                    else if (log.logtype == 5) {
                        logbody.push(
                            <NoteLog
                                thatAll={this}
                                log={log}
                                commentvalue={this.state.commentvalue}
                                selectedDate={this.state.selectedDate}
                                logid={this.state.logid}
                                dateformat={this.state.dateformat}
                                showSelector={this.state.showSelector}
                                isOpenedCommentIds={this.state.isOpenedCommentIds}
                                isEditComment={this.state.isEditComment}
                                commentid={this.state.commentid}
                                timeZone={this.state.timeZone}
                            />
                        )
                    }
                    else {
                        logbody.push(
                            <SystemLog log={log} />
                        )
                    }
                }
            })
            if (logbody && logbody.length > 0) {
                loghtml.push(logheader);
                loghtml.push(logbody);
            }
        })


        return (
            <>
                {allLogs && allLogs.length > 0 ?
                    <div>
                        {loghtml.map((month_log) => (
                            <div className="lead_upcoming">
                                <div className="box_portlet">
                                    {month_log}
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    <div className="isLogTabEmpty">
                        <div className="tab_empty_crm">
                            <div className="notabIcon">
                                <Icon style={{ fontSize: '50px', margin: '10px 10px 32px 10px' }}>mail</Icon>
                            </div>
                            <div className="notabTitle">No Email Logged Yet</div>
                        </div>
                    </div>
                }
                <Dialog fullWidth={true} maxWidth={'xs'} open={this.state.isDeleteLogConfirmDialoOpen} onClose={this.toggleDeleteDialog} disableBackdropClick aria-labelledby="ar-remove-dialog-title" >
                    <DialogTitle id="ar-remove-dialog-title">{"Are you sure you want to remove selected log ?"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={this.toggleDeleteDialog} color="primary"> Cancel </Button>
                        <Button type="Button" onClick={() => this.confirmDeleteLog()} className="btn_Primary"> Ok</Button>
                    </DialogActions>
                </Dialog>
                {this.state.shouldOpenViewEmailDialog && (
                    <ViewHtmlDialog
                        handleClose={this.handleViewEmailDialogClose}
                        open={this.state.shouldOpenViewEmailDialog}
                        logDatas={this.state.viewHtmlData}
                    />
                )}
                {this.state.isSendNewMail &&
                    <InboxComposeDialog
                        handleClose={this.isOpenedClickEmailToggle}
                        open={this.state.isSendNewMail}
                        userSelectedEmail={this.state.userSelectedEmail}
                        mainUserData={this.state.mainUserData}
                        LogDetails={{
                            opportunitiesid: parseFloat(this.state.opportunities_id),
                            emailid: localStorage.getItem('emailLogEmail') ? localStorage.getItem('emailLogEmail') : '',
                            logtypeid: this.state.logtypeid,
                            activitypeid: this.state.activitypeid,
                        }}
                        LogComponent="Opportunities"
                    />
                }
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        opportunityReducer: state.opportunityReducer,
        apolloClient: state.apolloClient,
        settingReducer: state.settingReducer
    };
};
const mapDispatchToProps = dispatch => {
    return {
        addLogPined: (client, request) => dispatch(actions.addLogPined(client, request)),
        getOpportunitiesLogListNew: (client, request) => dispatch(actions.getOpportunitiesLogListNew(client, request)),
        getActivityTypes: (client) => { dispatch(actions.getActivityTypes(client)) },
        saveOpportunitiesLog: (client, request) => dispatch(actions.saveOpportunitiesLog(client, request)),
        deleteOpportunitiesLogDetail: (client, request) => dispatch(actions.deleteOpportunitiesLogDetail(client, request)),
        updateOpportunitiesLog: (client, request) => dispatch(actions.updateOpportunitiesLog(client, request)),
        addOpportunitiesLogComment: (client, request) => dispatch(actions.addOpportunitiesLogComment(client, request)),
        updateOpportunitiesLogComment: (client, request) => dispatch(actions.updateOpportunitiesLogComment(client, request)),
        deleteOpportunitiesLogComment: (client, request) => dispatch(actions.deleteOpportunitiesLogComment(client, request)),
        addOpportunitiesLogEmoji: (client, request) => dispatch(actions.addOpportunitiesLogEmoji(client, request)),
        getEmailSetting: (client) => dispatch(actions.getEmailSetting(client)),
        customFieldList: (client, request) => { dispatch(actions.customFieldList(client, request)) },
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(OpportunitiesEmailLogs);